import { SERVICE_URL } from "./app.const";
import { fetchDelete, fetchPost, fetchPut } from "./response";
import { toCharacterUpdateRequest } from "../models/Character";

export function createCharacter(characterName, token) {
  return fetchPost(`${SERVICE_URL}/characters`, token, {
    headers: { "Content-Type": "application/json" },
    body: {
      characterName: characterName.trim(),
      json: {},
    },
  });
}

export function deleteCharacter(characterId, token) {
  return fetchDelete(`${SERVICE_URL}/characters/${characterId}`, token);
}

export function saveCharacter(character, token) {
  return fetchPut(
    `${SERVICE_URL}/characters/${character.id}`,
    token,
    { body: toCharacterUpdateRequest(character) }
  );
}

export function saveCharacterOnPageExit(character, token) {
  const body = JSON.stringify(toCharacterUpdateRequest(character));

  // keepalive gives the browser a chance to finish the request while the page closes.
  fetch(`${SERVICE_URL}/characters/${character.id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body,
    keepalive: true,
  }).catch(() => {});
}
